import { IWidgetConfiguration } from '../models';

export class GroupStatesConfiguration implements IWidgetConfiguration {
}